/**
 * Fixes blog post grids.
 */

( function($) {

    const className = 'et_mobile_menu';
    const selector = `.${className}`;

    const toggleSelector = '.mobile_menu_bar'

    $( window ).load( function() {

        // Remove all DIVI event listeners
        $( selector ).find( '*' ).off();
        $( selector ).off();

        // Handle submenu magic
        $( `${selector} .menu-item-has-children > a` ).on( 'click', function( event ) {
            event.preventDefault();  
            $( event.currentTarget ).siblings( '.sub-menu' ).addClass( 'is-active' );
        } );

        // Handle back-button magic
        $( `${selector} .back-button > a` ).on( 'click', function( event ) {
            $( event.currentTarget ).closest( '.sub-menu' ).removeClass( 'is-active' );
        } );

        // Handle toggle click
        $( `${toggleSelector}` ).on( 'click', function() {
            $( selector ).find( '.sub-menu' ).removeClass( 'is-active' );
        } );
    } );
    
} )( jQuery );